import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "../../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationStaticCenterBookingStepConfigurations,
  screeningStepConfigurations
} from "../../App/Compositions/StepConfigurations";
import { Flow } from "../../Types/IFlow";

const noWelcomeRebookFlowName = "NoWelcomeRebookFlow";

/** Legacy flow name alias. Routes users with cached "NoWelcomeRebookFlow" sessions to the no-confirmation experience. */
class NoWelcomeRebookFlow extends Flow {
  static readonly flowName = noWelcomeRebookFlowName;

  constructor(isPatientPreQualified: boolean) {
    isPatientPreQualified
      ? super(noWelcomeRebookFlowName, { ...noConfirmationStaticCenterBookingStepConfigurations }, [
          ...NoConfirmationPreQualifiedPatientNavigatorConfiguration
        ])
      : super(
          noWelcomeRebookFlowName,
          { ...screeningStepConfigurations, ...noConfirmationStaticCenterBookingStepConfigurations },
          [...NoConfirmationDefaultNavigatorConfiguration]
        );
  }
}

export default NoWelcomeRebookFlow;
